import {AppConfig} from '@frontend/AppConfig'
import {LocaleService} from '@frontend/services/LocaleService'
import {CacheServiceClass} from 'swayok-react-mdb-ui-kit/services/CacheService'

// Список групп опций.
type OptionsName = 'banks' | 'provinces' | 'categories' | 'locations'
    | 'support-menu' | 'rules-and-documents-menu' | 'support-question-types-options'
    | 'user-flags-polling' | 'user-data-polling'

// Сервис кеширования данные для модераторской.
// По умолчанию данные кешируются в window.localStorage.
export const CacheService = new CacheServiceClass<OptionsName>(
    '',
    false,
    120,
    () => LocaleService.primaryRegion.region,
    AppConfig.appVersion
)
